import { render, staticRenderFns } from "./Schematic.vue?vue&type=template&id=021a2d1a&"
import script from "./Schematic.vue?vue&type=script&lang=js&"
export * from "./Schematic.vue?vue&type=script&lang=js&"
import style0 from "./Schematic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports